var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import QueryBrowser from './query-browser.vue';
var DebugTool = /** @class */ (function (_super) {
    __extends(DebugTool, _super);
    function DebugTool() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabs = [
            { id: 'queries', title: pgettext('core.debug', 'Queries'), icon: 'fas fa-database' },
            { id: 'foo', title: pgettext('core.debug', 'Foo'), icon: 'fas fa-bug' },
        ];
        _this.isPanelExpanded = false;
        _this.activeTab = '';
        _this.isResizing = false;
        _this.resizeStartX = 0;
        _this.resizeStartWidth = 0;
        _this.isFullyExpanded = false;
        return _this;
    }
    DebugTool.prototype.mounted = function () {
        var _this = this;
        console.log(this.requestId);
        this.$refs.resizeHandle.addEventListener('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.isResizing = true;
            _this.resizeStartX = e.clientX;
            _this.resizeStartWidth = _this.$refs.panel.getBoundingClientRect().width;
        });
        document.addEventListener('mousemove', function (e) {
            if (!_this.isResizing) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            _this.$refs.panel.style.width = "".concat(_this.resizeStartWidth + (_this.resizeStartX - e.clientX), "px");
        });
        document.addEventListener('mouseup', function () {
            _this.isResizing = false;
        });
    };
    DebugTool.prototype.data = function () {
        return {
            activeTab: this.$route.params['tab'] || 'queries'
        };
    };
    __decorate([
        Prop({ type: String })
    ], DebugTool.prototype, "queriesEndpoint", void 0);
    __decorate([
        Prop({ type: String })
    ], DebugTool.prototype, "requestId", void 0);
    DebugTool = __decorate([
        Component({
            components: { QueryBrowser: QueryBrowser }
        })
    ], DebugTool);
    return DebugTool;
}(Vue));
export default DebugTool;
